module.exports = __webpack_public_path__ + "static/media/fedex.4c300100.svg";